import { FunctionComponent, useEffect, useState } from 'react';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';

// components
import FilePreview from 'components/filePreview/filePreview';
import { onGetDocuments } from '../services/documentsService';
import NotificationService from 'core/services/notification';
import { CompanyDocuments } from '../models/companyDocuments';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import NoData from 'components/noData/noData';

const ReviewDocumentComponent: FunctionComponent = () => {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);
	const [documents, setDocuments] = useState<CompanyDocuments>();

	useEffect(() => {
		getDocumentHandler();
	}, []);

	const getDocumentHandler = async () => {
		try {
			setIsLoading(true);

			const response = await onGetDocuments();

			const filtered = Object.entries(response.companyDocument).reduce((acc: any, [key, value]) => {
				const hasAnyValue = Object.values(value).some((v) => v !== null);
				if (hasAnyValue) {
					acc[key] = value;
				}
				return acc;
			}, {});
			setDocuments(filtered);

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
		}
	};

	return (
		<Card>
			{isLoading ? (
				<LoadingComponent />
			) : Object.keys(documents!).length === 0 ? (
				<NoData />
			) : (
				Object.entries(documents || {}).map(
					([key, value]) =>
						value.title && (
							<FilePreview
								key={key}
								name={value.title}
								data={`${value.last_modified_date} | ${value.size_in_kilobyte.toFixed(0)} KB`}
								downloadLink={value.download_link}
								className="mb-4"
							/>
						),
				)
			)}
		</Card>
	);
};

export default ReviewDocumentComponent;
